// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"925ee424","239":"79aae48c","488":"8c3a6032","557":"2788e841","732":"53a433c9","762":"dd12dfc4"}[chunkId] + ".chunk.js";
};